var _rect, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _circle, _mask, _g, _path4, _rect2, _mask2, _g2, _path5, _rect3, _rect4, _path6, _path7, _path8, _rect5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormPublisherLogoNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8.2168,
    width: 31.6807,
    height: 18.419,
    rx: 9.20951,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2401 1.81472C24.7209 1.93356 25.05 2.37037 25.05 2.86566V8.95397H6.63101V2.86566C6.63101 2.37037 6.96012 1.93356 7.44094 1.81472C9.92858 1.19983 12.7926 0.849609 15.8405 0.849609C18.8885 0.849609 21.7525 1.19983 24.2401 1.81472Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0631 10.1297L27.5766 6.50195L28.0596 6.58239L27.546 10.2102L27.0631 10.1297Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9442 10.4173L29.7441 9.10645L30.018 9.48142L28.2181 10.7923L27.9442 10.4173Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.13551,
    ry: 1.07355,
    transform: "matrix(0.984264 0.173155 -0.132783 0.990701 27.8967 6.17035)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.13551,
    ry: 1.07356,
    transform: "matrix(0.984264 0.173155 -0.132783 0.990702 30.4741 8.80316)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.11271,
    cy: 23.7036,
    rx: 0.73676,
    ry: 0.736761,
    fill: "#DFD8FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5768,
    cy: 23.7006,
    r: 0.736761,
    fill: "#DFD8FF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 30,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20946 9.69043C4.937 9.69043 1.47348 13.1539 1.47348 17.4264C1.47348 21.6989 4.937 25.1624 9.20947 25.1624H22.4712C26.7436 25.1624 30.2071 21.6989 30.2071 17.4264C30.2071 13.1539 26.7436 9.69043 22.4712 9.69043H9.20946ZM9.20951 11.164C5.75085 11.164 2.94705 13.9678 2.94705 17.4264C2.94705 20.8851 5.75085 23.6889 9.20951 23.6889H22.4712C25.9299 23.6889 28.7337 20.8851 28.7337 17.4264C28.7337 13.9678 25.9299 11.164 22.4712 11.164H9.20951Z",
    fill: "#DFD8FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48959 22.8814L25.1591 22.8389L26.3661 25.2199L5.39154 25.3041L6.48959 22.8814Z",
    fill: "#DFD8FF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8396 29.9994C22.8396 30.2668 22.6481 30.4963 22.3842 30.5399C20.3653 30.8733 18.1559 31.0571 15.8403 31.0571C13.5248 31.0571 11.3154 30.8733 9.2965 30.5399C9.03262 30.4963 8.84113 30.2668 8.84113 29.9994V23.6895H22.8396V29.9994Z",
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 8.84113,
    y: 23.6895,
    width: 13.9984,
    height: 0.7515,
    fill: "black"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 32,
    height: 19
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.6807,
    height: 18.419,
    rx: 9.20951,
    transform: "matrix(1 0 0 -1 0 26.6357)",
    fill: "#6246E4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15729 8.21702C5.15729 9.84463 6.47672 11.1641 8.10433 11.1641H23.5763C25.2039 11.1641 26.5233 9.84463 26.5233 8.21702H5.15729Z",
    fill: "#DFD8FF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15729 17.4272C5.15729 15.1892 6.97151 13.375 9.20947 13.375H22.4712C24.7091 13.375 26.5233 15.1892 26.5233 17.4272C26.5233 19.6651 24.7091 21.4794 22.4712 21.4794H9.20948C6.97152 21.4794 5.15729 19.6651 5.15729 17.4272Z",
    fill: "#DFD8FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3149,
    y: 14.8486,
    width: 2.21028,
    height: 3.6838,
    rx: 1.10514,
    fill: "#6246E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1558,
    y: 14.8486,
    width: 2.21028,
    height: 3.6838,
    rx: 1.10514,
    fill: "#6246E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1644 3.2752C22.1644 3.01178 21.9785 2.78449 21.7193 2.73723C19.9138 2.40793 17.9396 2.22656 15.8712 2.22656C13.8028 2.22656 11.8286 2.40793 10.023 2.73723C9.76389 2.78449 9.57803 3.01178 9.57803 3.2752V9.59417H22.1644V3.2752Z",
    fill: "url(#paint1_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.152 3.9359C20.2277 3.56965 18.0985 3.36621 15.8588 3.36621C13.6192 3.36621 11.49 3.56965 9.56567 3.9359V10.4146H22.152V3.9359Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8396 5.35746C22.8396 5.09001 22.6481 4.86056 22.3843 4.81698C20.3654 4.48357 18.156 4.2998 15.8404 4.2998C13.5248 4.2998 11.3154 4.48357 9.29656 4.81698C9.03268 4.86056 8.84119 5.09001 8.84119 5.35746V11.164H22.8396V5.35746Z",
    fill: "url(#paint2_linear)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 8.84119,
    y: 10.4268,
    width: 13.9984,
    height: 0.751498,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.8403,
    y1: 23.6895,
    x2: 15.8403,
    y2: 31.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.8712,
    y1: 2.22656,
    x2: 15.8712,
    y2: 10.1345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.8404,
    y1: 4.2998,
    x2: 15.8404,
    y2: 11.6674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPublisherLogoNegative);
export default __webpack_public_path__ + "static/media/form-publisher-logo-negative.c73d2158.svg";
export { ForwardRef as ReactComponent };